

import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IShortLocker} from "@/model/shortInterfaces";
import ChipMixin from "@/components/shared/chips/ChipMixin";

@Component({
  mixins: [ChipMixin]
})
export default class LockerChip extends ChipMixin {

  @Prop()
  protected item!: IShortLocker;
  @Prop({type: Boolean, default: false})
  protected withCity!: boolean;

  protected toUrl(): any {
    return this.itemId ? {name: 'installLocker', params: {lockerId: this.itemId}} : null;
  }

  protected get caption(): string|null {
    return this.withCity
        ? (this.item||{}).community_location_city || null
        : null;
  }

}

